import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IDisabledRecipient  } from "../../services/admin-report-data-service/Models";
import AdminReportDataService from "../../services/admin-report-data-service/AdminReportDataService";

export type UseDisabledRecipientsReportParams = {
    contextGroupID: number,
    startDate: Date,
    endDate: Date,
} & BaseUseQueryParameters<IDisabledRecipient[] | undefined>;

export function useDisabledRecipientsReport({
    contextGroupID,
    startDate,
    endDate,
    enabled,    
    onSuccess,
    onError
}: UseDisabledRecipientsReportParams) {
    return useQuery<IDisabledRecipient[], RestError>(
        keys.disabledRecipientsReport(contextGroupID, startDate, endDate),
        ({ signal }) => {
            return AdminReportDataService.getDisabledRecipients(
                contextGroupID,
                startDate,
                endDate,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchOnMount: true,
            refetchInterval: false,
            staleTime: Infinity,
        }
    );
}